import { useEffect, useState } from 'react';
import { showToast } from '@deeptrue-frontend/ui';
import { OrganizationType } from 'store/modules/auth/auth';
import { useFormatMessage } from 'components/IntlProvider';
import { useParams } from 'react-router-dom';
import api from 'api';

interface LimitData {
  limit: number;
  available_limit: number;
  reserved_tokens: number;
  available_tokens: number;
}

interface Props {
  organization: OrganizationType;
}

const usePaymentsLimits = ({ organization }: Props) => {
  const params = useParams<{ codename?: string }>();
  const [limitsRes, setLimitsRes] = useState<LimitData>({
    limit: 0,
    available_limit: 0,
    reserved_tokens: 0,
    available_tokens: 0,
  });
  const [arePaymentInformationLoaded, setPaymentInformationLoaded] = useState(
    false
  );
  const t = useFormatMessage();

  useEffect(() => {
    api.resources
      .getOrganizationPaymentLimits(params.codename || organization.codename)
      .then(({ data }) => {
        setLimitsRes(data);
        setPaymentInformationLoaded(true);
      })
      .catch(() => {
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
    /* eslint-disable-next-line */
  }, [organization.codename]);

  return { limitsRes, arePaymentInformationLoaded };
};

export default usePaymentsLimits;
